export var FlagSynchStatus;
(function (FlagSynchStatus) {
    FlagSynchStatus[FlagSynchStatus["CREATED"] = 0] = "CREATED";
    FlagSynchStatus[FlagSynchStatus["CONTEXT_UPDATED"] = 1] = "CONTEXT_UPDATED";
    FlagSynchStatus[FlagSynchStatus["FLAGS_FETCHED"] = 2] = "FLAGS_FETCHED";
    FlagSynchStatus[FlagSynchStatus["AUTHENTICATED"] = 3] = "AUTHENTICATED";
    FlagSynchStatus[FlagSynchStatus["UNAUTHENTICATED"] = 4] = "UNAUTHENTICATED";
})(FlagSynchStatus || (FlagSynchStatus = {}));
